import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {CrossBrandListDefaultBox} from "./cross-brand-list.default.box";

export const CrossBrandListBox = styledByTheme(CrossBrandListDefaultBox).apply();
